<template>
    <div class="d-flex flex-row flex-wrap justify-content-start gap-3">
        <div
            v-for="status in statuses"
            :key="status.id"
            class="status-block p-2 me-3 mb-3 mb-md-0 rounded text-center"
            :class="{ 'selected': record.status === status.id}"
            @click="changeStatus(status.id)"
        >
            <icon :icon="status.icon" class="status_icon" />
            <div class="fs-6 fw-bold">{{ $t("status." + statusType + "." + status.name) }}</div>
            <input
                type="radio"
                class="d-none"
                :checked="record.status === status.id"
            >
        </div>
    </div>
</template>

<script>
    import Icon from '@/components/Icon.vue'

    export default {
        components: {
            Icon,
        },
        props: {
            record: Object,
            statusType: String,
            getUrl: String,
            submitUrl: String,
            modalId: String,
        },
        data() {
            return {
                statuses: [],
            }
        },
        created() {
            this.getStatuses();
        },
        methods: {
            getStatuses() {
                this.$store.getters.api.get(this.getUrl)
                .then(response => {
                    this.statuses = response.data;
                })
                .catch(error => {
                    console.error("Error loading statuses", error);
                });
            },
            changeStatus(statusId) {
                const selectedStatus = this.statuses.find(s => s.id === statusId)
                this.$store.getters.api.patch(this.submitUrl, { status: statusId })
                .then(() => {
                    this.record.status = statusId;
                    this.record.status_name = selectedStatus.name;
                    document.querySelector(`#${this.modalId} .btn-close`)?.click();
                    this.$emit("status-updated", {
                        id: this.record.id,
                        status: statusId,
                        status_name: selectedStatus.name
                    });
                })
                .catch(error => {
                    console.error("Failed to update status", error);
                });
            }
        }
    }
</script>

<style scoped>
    .status_icon {
        width: 40px;
        height: 40px;
    }
</style>